import { useSession } from 'next-auth/react';
import { useGlobalAlertStore } from 'store/globalToastStore';

const useDemandHooks = () => {
    const session = useSession();
    const { setAlertData } = useGlobalAlertStore();

    const isAdminOrRM = ['resource_manager'].some((role) => session.data?.user?.role?.includes(role));
    const isPartner = session.data?.user?.gradeLevel?.toLowerCase() === 'partner';
    const budgetExceededMessage = () => {
        if (isPartner) {
            return {
                title: 'Budget Approval Pending',
                message: 'There is a pending budget approval request against this demand. Please review the pending budget approval request under the Partner review tab and try again'
            }
        } else {
            return {
                title: 'Budget Approval Pending',
                message: 'There is a pending budget approval request against this demand. Please reach out to the engagement partner for further action'
            }
        }
    }

    const scheduleConflictMessageInProjectPage = (employeeName) => {
        if (isAdminOrRM) {
            return {
                message: `This demand has an existing schedule conflict for an employee ${employeeName}. Please resolve the conflict under the RM review tab and try again.`,
                title: 'Demand Has a Schedule Conflict for an Employee!'
            }
        } else {
            return {
                title: 'Demand Has a Schedule Conflict for an Employee!',
                message: `This demand has an existing schedule conflict for an employee ${employeeName}. Please reach out to your RM and try again.`,
            }
        }
    }

    const scheduleConflictMessageInDemandPage = () => {
        if (isAdminOrRM) {
            return {
                message: `This demand has an existing schedule conflict for an employee. Please resolve the conflict under the RM review tab and try again.`,
                title: 'Demand Has a Schedule Conflict for an Employee!'
            }
        } else {
            return {
                title: 'Demand Has a Schedule Conflict for an Employee!',
                message: `This demand has an existing schedule conflict for an employee. Please reach out to your RM and try again.`,
            }
        }
    }



    function onHavingConflictShowAlert(employeeName, isProjectPage = false) {
        if(isProjectPage){
            const data = scheduleConflictMessageInProjectPage(employeeName);
            setAlertData({
                show: true,
                saveLabel: 'Ok',
                title: data.title,
                message: data.message,
            })
        }else{
            const data = scheduleConflictMessageInDemandPage();
            setAlertData({
                show: true,
                saveLabel: 'Ok',
                title: data.title,
                message: data.message,
            })
        }
      
    }

    function onHavingBudgetExceededShowAlert() {
        const { title, message } = budgetExceededMessage();
        setAlertData({
            show: true,
            saveLabel: 'Ok',
            title,
            message
        })
    }
    return { onHavingConflictShowAlert, onHavingBudgetExceededShowAlert };
};

export default useDemandHooks;